<template>
    <div class="unsubscribe">
        <div class="unconfirmed" v-if="!confirmed">
            <p>Are you sure you want to unsubscribe from this booster program? You will not receive any more boosters from this program.</p>
            <br />
            <button id="confirmButton" class="ui button primary" @click="confirmUnsubscribe">Unsubscribe Me</button>
        </div>
        <div class="confirmed" v-if="confirmed">
            <p>You are now unsubscribed from this booster program. You may close this page.</p>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Unsubscribe',
    props: [ 'boosterData', 'api', 'programId', 'learnerId' ],
    mounted: function() {
        this.confirmed = this.boosterData.confirmed
    },
    data() {
        return {
            confirmed: false
        }
    },
    methods: {
        confirmUnsubscribe: async function() {
            await this.api.post('/api/unsubscribe', {
                pid: this.programId,
                lid: this.learnerId
            }).then((response) => {
                if (response.data.message == 'success') {
                    this.confirmed = true
                    this.$router.replace('/booster/unsubscribe-confirm/'+this.boosterData.pid+'/'+this.boosterData.lid)
                }
            })
        }
    }
}
</script>